import { useState } from 'react';

const faqs = [
  {
    question: 'Quem nunca contribuiu pode receber algum benefício?',
    answer: 'Sim. No caso do BPC/LOAS, é possível receber mesmo sem nunca ter contribuído, desde que a pessoa se enquadre nos critérios de renda, idade ou condição de saúde estabelecidos pela legislação.',
  },
  {
    question: 'Tive meu benefício negado. Ainda posso recorrer?',
    answer: 'Sim! A negativa não é o fim. É possível entrar com recurso administrativo ou ação judicial, dependendo do caso e do prazo disponível. Analisamos cada situação para identificar a melhor estratégia.',
  },
  {
    question: 'O processo pelo INSS demora muito?',
    answer: 'Em muitos casos, sim. Mas com acompanhamento jurídico especializado é possível agilizar prazos, evitar erros que atrasam o processo e pressionar administrativamente quando necessário.',
  },
  {
    question: 'Vocês atendem aposentadoria rural?',
    answer: 'Sim, temos experiência consolidada na comprovação da atividade rural, inclusive em casos sem registro formal em carteira de trabalho.',
  },
  {
    question: 'É possível resolver tudo sem sair de casa?',
    answer: 'Sim! Nosso atendimento é 100% remoto — seguro, prático e eficiente. Você envia os documentos digitalmente e recebe suporte completo do início ao fim.',
  },
  {
    question: 'Estou desempregado. Posso pedir BPC ou salário-maternidade?',
    answer: 'Pode sim. Alguns benefícios não exigem vínculo empregatício atual. Cada caso precisa ser analisado individualmente — entre em contato para uma avaliação personalizada.',
  },
  {
    question: 'Como funciona a análise do meu caso?',
    answer: 'Fazemos uma análise personalizada com base nos seus dados e documentos, identificando os benefícios possíveis e a melhor estratégia. O processo é simples e objetivo.',
  },
  {
    question: 'Quais documentos preciso separar?',
    answer: 'Depende do tipo de benefício. Mas não se preocupe: orientamos você a reunir toda a documentação necessária e acompanhamos cada passo do processo.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="bg-brand-warm py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-start">

          {/* Left: Info column */}
          <div className="lg:col-span-2 lg:sticky" style={{ top: '100px' }}>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-6 h-px bg-brand-gold" />
              <span className="font-inter text-xs font-medium text-brand-gold uppercase tracking-[0.18em]">
                Dúvidas Frequentes
              </span>
            </div>
            <h2 className="font-cormorant text-4xl font-semibold text-brand-dark leading-tight mb-6">
              Perguntas
              <br />
              <span className="italic">Frequentes</span>
            </h2>
            <p className="font-inter text-sm text-brand-muted leading-relaxed mb-8">
              Respondemos as principais dúvidas sobre benefícios do INSS. Se sua pergunta não estiver aqui, fale conosco diretamente.
            </p>

            {/* Contact card */}
            <div className="bg-white border border-brand-border rounded-xl p-6">
              <div className="w-9 h-9 flex items-center justify-center bg-brand-cream rounded-md mb-4">
                <i className="ri-customer-service-2-line text-brand-gold text-base" />
              </div>
              <p className="font-playfair font-semibold text-brand-dark text-base mb-1">
                Não encontrou sua dúvida?
              </p>
              <p className="font-inter text-xs text-brand-muted mb-4 leading-relaxed">
                Fale diretamente com a advogada pelo WhatsApp.
              </p>
              <a
                href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20ba5a] text-white font-inter font-medium text-xs px-5 py-2.5 rounded-md transition-all duration-200"
              >
                <i className="ri-whatsapp-line text-sm" />
                Enviar mensagem
              </a>
            </div>
          </div>

          {/* Right: Accordion */}
          <div className="lg:col-span-3">
            {faqs.map((faq, i) => (
              <div key={i} className="border-b border-brand-border">
                <button
                  className="w-full flex items-start justify-between gap-5 py-5 text-left cursor-pointer group"
                  onClick={() => toggle(i)}
                >
                  <span className={`font-inter text-sm font-medium leading-snug transition-colors duration-200 ${openIndex === i ? 'text-brand-dark' : 'text-brand-charcoal group-hover:text-brand-dark'}`}>
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full border transition-all duration-200 mt-0.5 ${openIndex === i ? 'border-brand-gold bg-brand-gold' : 'border-brand-border'}`}>
                    <i className={`${openIndex === i ? 'ri-subtract-line text-white' : 'ri-add-line text-brand-muted'} text-xs`} />
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-56 pb-5' : 'max-h-0'}`}>
                  <p className="font-inter text-sm text-brand-muted leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
